<!-- DESKTOP -->
<div class="desktop edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <span class="icon">
            <img alt="" src="/resource/image/{{ partner?.image_code }}" />
        </span>
        <div class="description" [innerHTML]="labelDescription | translate"></div>
    </div>
</div>



<!-- MOBILE -->
<div class="mobile edp-card-widget card">
    <div class="card-header">
        <span class="card-title-small">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <div class="description-mobile" [innerHTML]="labelDescriptionMobile | translate"></div>
    </div>
</div>

